// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"43e13baf","248":"d6835773","597":"44f7f16c","962":"07d937d4"}[chunkId] + ".chunk.css";
};